import React from "react";
import { Grid, Loader } from "semantic-ui-react";
import { useGetMyRecords } from "../../hooks";
import { TotalInfoCard } from "./TotalInfoCard";
import { DraftInfoCard } from "./DraftInfoCard";

export const computeDashboardStats = (data) => {
  const dataStateInfo = data?.aggregations?.state || {};
  const buckets = dataStateInfo?.buckets || [];

  const totalHits = data?.hits?.total || 0;

  const bucketCount = (key) => {
    const b = buckets.find((x) => x.key === key);
    return b ? b.doc_count || 0 : 0;
  };

  const publishedCount = bucketCount("published");
  const draftsCount = bucketCount("draft");
  const errorCount = bucketCount("error");

  const unpublishedCount =
    totalHits && Math.max(0, totalHits - publishedCount) > 0
      ? Math.max(0, totalHits - publishedCount)
      : buckets
          .filter((b) => b.key !== "published")
          .reduce((sum, b) => sum + (b.doc_count || 0), 0);

  const stats = [
    {
      title: "Drafts",
      count: draftsCount,
      filter: "state:draft",
    },
    {
      title: "Failed Quality Checks",
      count: errorCount,
      filter: "state:error",
    },
    {
      title: "Unpublished",
      count: unpublishedCount,
      filter: "-state:published",
    },
    {
      title: "Published",
      count: publishedCount,
      filter: "state:published",
    },
  ];

  const assetsCount = totalHits || publishedCount + unpublishedCount;

  return { stats, assetsCount };
};

const DashboardSearchStatistics = () => {
  const { data, isLoading } = useGetMyRecords({ page: 1, size: 1 });

  if (isLoading) {
    return <Loader />;
  }

  const { stats, assetsCount } = computeDashboardStats(data);

  return (
    <Grid className="ui computer tablet only full-width spaced-horizontally">
      <Grid.Row columns={3} stretched>
        <Grid.Column width={3}>
          <Grid columns={1}>
            <Grid.Row stretched>
              <Grid.Column>
                <TotalInfoCard count={assetsCount} />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Column>

        <Grid.Column width={1} />

        <Grid.Column width={12}>
          <Grid columns={stats.length}>
            <Grid.Row stretched>
              {stats.map((s, idx) => (
                <Grid.Column key={idx}>
                  <DraftInfoCard
                    title={s.title}
                    count={s.count}
                    filter={s.filter}
                  />
                </Grid.Column>
              ))}
            </Grid.Row>
          </Grid>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default DashboardSearchStatistics;
